module.exports = __webpack_public_path__ + "static/img/10.277cd31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/10.jpg
// module id = 9ORe
// module chunks = 1